var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 68,
    viewBox: "0 0 88 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.53512 1.25671H0.555664V15.1975H4.53512C6.63891 15.1975 8.15973 14.6906 9.50311 13.6006C11.1 12.2826 12.0378 10.3055 12.0378 8.25245C12.0125 4.12091 8.94548 1.25671 4.53512 1.25671ZM7.72883 11.7503C6.86704 12.5107 5.77712 12.8656 4.00284 12.8656H3.26778V3.63932H4.00284C5.75177 3.63932 6.81634 3.94348 7.72883 4.75458C8.66667 5.59103 9.22429 6.88372 9.22429 8.2271C9.22429 9.57049 8.66667 10.9139 7.72883 11.7503Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_422_",
    d: "M15.9919 1.25671H13.2798V15.1975H15.9919V1.25671Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    d: "M22.6323 6.60529C21.0101 5.99696 20.5285 5.59141 20.5285 4.85635C20.5285 3.96921 21.3903 3.31019 22.5563 3.31019C23.3674 3.31019 24.0518 3.6397 24.7361 4.4508L26.1555 2.60048C24.9896 1.58661 23.5955 1.05432 22.0494 1.05432C19.5907 1.05432 17.6897 2.77791 17.6897 5.05913C17.6897 6.98549 18.5768 7.97402 21.1115 8.8865C22.1761 9.26671 22.7084 9.52018 22.9872 9.67226C23.5195 10.0271 23.7983 10.5341 23.7983 11.117C23.7983 12.2576 22.9111 13.0941 21.6945 13.0941C20.4018 13.0941 19.3626 12.4351 18.7289 11.2438L16.98 12.942C18.222 14.7923 19.7428 15.6034 21.7959 15.6034C24.6094 15.6034 26.6118 13.7278 26.6118 11.0156C26.6625 8.75977 25.7247 7.74589 22.6323 6.60529Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    d: "M27.5 8.25278C27.5 12.359 30.7191 15.5273 34.8506 15.5273C36.0165 15.5273 37.0304 15.2992 38.2471 14.7162V11.5225C37.1572 12.6124 36.194 13.0433 34.9773 13.0433C32.2399 13.0433 30.2882 11.0663 30.2882 8.22743C30.2882 5.54066 32.2906 3.43687 34.8506 3.43687C36.1433 3.43687 37.1318 3.89312 38.2471 5.00838V1.81467C37.0558 1.20635 36.0672 0.952881 34.9013 0.952881C30.8204 0.952881 27.5 4.19728 27.5 8.25278Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_419_",
    d: "M59.8429 10.6351L56.117 1.25671H53.1514L59.0572 15.5524H60.5273L66.5345 1.25671H63.5943L59.8429 10.6351Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    d: "M67.7754 15.1975H75.4808V12.8402H70.4875V9.0889H75.3034V6.73164H70.4875V3.63932H75.4808V1.25671H67.7754V15.1975Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M86.2536 5.3883C86.2536 2.77757 84.4539 1.2821 81.3109 1.2821H77.2808V15.2229H79.9929V9.62123H80.3477L84.0991 15.2229H87.4449L83.0598 9.34241C85.1129 8.91151 86.2536 7.51744 86.2536 5.3883ZM80.7786 7.69486H79.9929V3.46194H80.8293C82.5276 3.46194 83.44 4.17165 83.44 5.54038C83.44 6.93446 82.5276 7.69486 80.7786 7.69486Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_415_",
    d: "M46.5844 15.7047C50.686 15.7047 54.011 12.3797 54.011 8.27808C54.011 4.17646 50.686 0.85144 46.5844 0.85144C42.4827 0.85144 39.1577 4.17646 39.1577 8.27808C39.1577 12.3797 42.4827 15.7047 46.5844 15.7047Z",
    fill: "#C8283B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.5437f5bd837b131b231563d8be331f55.svg";
export { ForwardRef as ReactComponent };